import { render, staticRenderFns } from "./addNewTr.vue?vue&type=template&id=1ed1624a&"
import script from "./addNewTr.vue?vue&type=script&lang=js&"
export * from "./addNewTr.vue?vue&type=script&lang=js&"
import style0 from "./addNewTr.vue?vue&type=style&index=0&id=1ed1624a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports